import React, {useEffect, useState, useContext} from "react";
import {injectIntl} from "react-intl";
import AisleLabel from "./AisleLabel";
import Bin from "./Bin";
import {
    formatAisleLabel,
    getColumnSensorStateValues, getExhaustiveLabelSet,
    getMqttTopicForLidarTester,
    getSortedAssetByAisle
} from "../../../util/LidarTesterUtil";
import {LidarTesterContext} from "../context/LidarTesterContext";
import MQTTUtility from "../../../util/MQTTUtility";
import {chainWalk, getMQTTClientConfig, getNodeId} from "../../../util/Util";
import ColumnLabelRow from "./ColumnLabelRow";
import Alert from "@amzn/meridian/alert";
import {getLocalizedMessage} from "../../../util/Localization";

const GRID_STYLE = {
    display: "flex"
}

const LidarTesterGridView = (props) => {

    const {selectedMac ,device, intl} = props;
    const {testerViewModel, testerDispatch} = useContext(LidarTesterContext);
    const [error, setError] = useState(false)
    const [isSubscribing, setIsSubscribing] = useState(false)

    const sortedAssetByAisle = device && getSortedAssetByAisle(device);
    const exhaustiveLabelSet = device && getExhaustiveLabelSet(device);

    useEffect(() => {
        if (device) {
            testerDispatch({
                type: "LOAD_STATE_MAP", data: {
                    sortedAssetByAisle, dispatcher: testerDispatch,
                    macAddress: device.mac, columnsList: exhaustiveLabelSet
                }
            });
        }
    }, [device])

    const onMessage = (message) => {
        const parsedData = JSON.parse(message.toString())
        testerDispatch({
            type: "UPDATE_STATE_MAP",
            data: {dispatcher: testerDispatch, message: parsedData}
        });
    }

    const mqttUtilityProps = () => {
        return {
            topic: getMqttTopicForLidarTester(getNodeId() ,device.ip),
            config: getMQTTClientConfig(),
            onMessage,
            setError,
            setIsSubscribing,
            isSubscribing
        }
    }

    const getBinColumnProps = (aisleLabel, label) => {
        return {
            sensorStates: chainWalk(() => getColumnSensorStateValues(
                testerViewModel.sensorStateMap[aisleLabel][label]), null),
            isAnomaly: chainWalk(() => !testerViewModel.sensorStateMap[aisleLabel][label], null),
            columnLabel: label
        }
    }

    return (
        <div>
            {selectedMac && <MQTTUtility {...mqttUtilityProps()}/>}
            {error && <Alert type="error">{getLocalizedMessage({intl, stringId: 'log.error'})}</Alert>}
            {exhaustiveLabelSet && <ColumnLabelRow {...{labelList: exhaustiveLabelSet}}/>}
            {sortedAssetByAisle && sortedAssetByAisle.map((assetMapping) => {
            return (
                <div style={GRID_STYLE}>
                    <AisleLabel {...{aisleLabel: assetMapping.aisleLabel}}/>
                    {exhaustiveLabelSet && exhaustiveLabelSet.map((label) =>
                        <Bin {...getBinColumnProps(formatAisleLabel(assetMapping.aisleLabel), label)}/>)}
                </div>
            )
        })}
        </div>
    )
}

export default injectIntl(LidarTesterGridView);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/LidarTesterGridView.js